import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { MetaService } from '@bo-client/core/api/meta-service';
import { combineLatestWith, map, startWith, takeUntil } from 'rxjs/operators';
import { ContactDataForm } from '@bo-client/shared/models/contactDataDto';
import { initContactDataSalutationSubscription } from '@bo-client/shared/forms/contact-form/contact-data-salutation.subscription';

@Component({
  selector: 'app-contact-address-formpart',
  templateUrl: './contact-address-formpart.component.html',
  styleUrls: ['./contact-address-formpart.component.scss']
})
export class ContactAddressFormpartComponent implements OnInit, OnDestroy {
  @Input() formGroup: ContactDataForm;
  @Input() isRequired = true;

  ngUnsubscribe$: Subject<void> = new Subject<void>();

  salutations$ = of([]);
  isPerson$: Observable<boolean>;
  @Input() disable!: boolean;

  constructor(private metaService: MetaService) {
    this.salutations$ = this.metaService.salutationValues$;
  }

  ngOnInit(): void {
    initContactDataSalutationSubscription(this.formGroup, this.metaService, this.ngUnsubscribe$);

    this.isPerson$ = this.metaService.salutationValues$.pipe(
      combineLatestWith(
        this.formGroup.controls.salutation.valueChanges.pipe(startWith(this.formGroup.value.salutation))
      ),
      takeUntil(this.ngUnsubscribe$),
      map(([salVals, formValue]) => {
        return (
          salVals.find((SalutationValue) => SalutationValue.id === formValue)?.type?.toLowerCase() ===
          'Person'.toLowerCase()
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
